import type { MouseEvent } from "react";
import React, { useMemo } from "react";
import cx from "classnames";
import { UncontrolledTooltip } from "reactstrap";
import { Icon } from "components";
import type { IconName } from "components/Icon/iconNames";
import s from "./IconButton.module.scss";

type IconButtonProps = {
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  type?: "button" | "submit" | "reset";
  className?: string;
  disabled?: boolean;
  iconClassName?: string;
  icon: IconName;
  title?: string;
  testId?: string;
  tooltipText?: React.JSX.Element | string;
  color?: string;
  hoverColor?: string;
  id?: string;
};

export const IconButton = ({
  onClick = () => {},
  type = "button",
  className,
  disabled = false,
  iconClassName = "icon-16",
  icon,
  title,
  testId,
  tooltipText,
  id,
}: IconButtonProps) => {
  const iconId = useMemo(() => `iconButton-${id || crypto.randomUUID()}`, [id]);

  return (
    <>
      <button
        type={type}
        className={cx(s.iconButton, className)}
        onClick={(e: MouseEvent<HTMLButtonElement>) => !disabled && onClick(e)}
        data-testid={testId}
        title={title}
        id={iconId}
        disabled={disabled}
      >
        <Icon iconName={icon} className={iconClassName} />
      </button>
      {tooltipText && (
        <UncontrolledTooltip target={iconId} placement="top">
          {tooltipText}
        </UncontrolledTooltip>
      )}
    </>
  );
};
